module.exports = __webpack_public_path__ + "static/media/herb-cat.09929b77.PNG";